document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.nav-tabs_tab');
    const cards = document.querySelectorAll('.nav-tabs_content__card');

    tabs.forEach(tab => {
        tab.addEventListener('click', function () {
            const idx = tab.getAttribute('data-index');

            tabs.forEach(t => t.classList.remove('active'));
            cards.forEach(c => c.classList.remove('active'));

            tab.classList.add('active');
            document.querySelectorAll('.nav-tabs_content__card[data-index="' + idx + '"]').forEach(c => c.classList.add('active'));
        });
    });
});